import getSubscriptionIntervalWithSlash from '../services/translation/getSubscriptionIntervalWithSlash';

/**
 * The Interval / Currency suffix text for a variant PWYW input, mirroring
 * VariantOptionIntervalSuffix (interval for a recurring option) with a currency
 * fallback for one-time options (matching the picker's PWYW currency suffix).
 */
export default function getVariantPwywSuffix({
  option,
  showInterval,
  effectiveInterval,
  currency,
  labels = {},
}) {
  if (showInterval && effectiveInterval) {
    return getSubscriptionIntervalWithSlash(
      effectiveInterval.interval,
      effectiveInterval.intervalCount,
      labels,
    );
  }
  if (option?.type === 'recurring') {
    return `/ ${labels.recurringText ?? 'recurring'}`;
  }
  return currency ? currency.toUpperCase() : '';
}
